export default __webpack_public_path__ + "static/atom_photon-7da74fbe70e3971f7ce86deab1f3720d.mp4";